import { http } from '../../../api/axios';
import { localContentPrefix } from '../../../config';

export const removeLocalContentCopies = async (productId: string): Promise<void> => {
    return await http.delete(`${localContentPrefix}/v1/localcollectioncontent/:productId/remove`, {
        pathParams: { productId }
    });
};
